// Models
import { Ocupation } from "../../models/ocupation";
import { Sector } from "../../models/sector";
import { Study } from "../../models/study";
import { StudyDegree } from "../../models/study-degree";

// URLs
import { GET_HAS_REGULATED_TRAINING, GET_HAVE_EXPERIENCE_URL, GET_KQ_URL, GET_OCUPATION_URL, GET_SECTORS_URL, GET_STUDIES_DEGREES_URL, GET_STUDIES_URL, SET_EXPERIENCE_URL, SET_FORMATION_URL, SET_HAVE_NO_EXPERIENCE_URL, SET_HAVE_NO_REGULATED_TRAINING_URL } from "./settings";

// Resources
import { catchError } from "../../catchErrors";

export async function addFormationRequest(studyDegree: string, study: string, period?: number): Promise<boolean> {
    try {
        const data = new URLSearchParams();
        data.append('StudyDegree', studyDegree);
        data.append('Study', study);
        if(period) data.append('Period', period.toString());
        await fetch(SET_FORMATION_URL, { 
          method: 'POST',
          body : data
        }); 
        return true;
    } catch(error) {
        catchError(error);
        return false;
    }
}

export async function getStudies(studyDegree: string): Promise<Array<Study>> {
    try {
        const response: Response = await fetch(`${GET_STUDIES_URL}?degree=${studyDegree}`);
        const studies: Array<Study> = await response.json();
        return studies;
    } catch(error) {
        catchError(error);
        return [];
    }
}

export async function getStudiesDegrees(): Promise<Array<StudyDegree>> {
    try {
        const response = await fetch(GET_STUDIES_DEGREES_URL);
        const studiesDegrees: Array<StudyDegree> = await response.json();
        return studiesDegrees;
    } catch(error) {
        catchError(error);
        return [];
    }
}

export async function getHasRegulatedTraining(): Promise<boolean> {
    try {
        const response: Response = await fetch(GET_HAS_REGULATED_TRAINING)
        return response.status === 204;
    } catch(error) {
        catchError(error);
        return false;
    }
}

export async function setHaveNoRegulatedTraining(): Promise<boolean> {
    try {
        await fetch(SET_HAVE_NO_REGULATED_TRAINING_URL, { method: 'POST' });
        return true;
    } catch(error) {
        catchError(error);
        return false;
    }
}

export async function getSectors(): Promise<Array<Sector>> {
    try {
        const response = await fetch(GET_SECTORS_URL);
        const sectors: Array<Sector> = await response.json();
        return sectors;
    } catch(error) {
        catchError(error);
        return [];
    }
}

export async function getOcupations(): Promise<Array<Ocupation>> {
    try {
        const response = await fetch(GET_OCUPATION_URL);
        const ocupations: Array<Ocupation> = await response.json();
        return ocupations;
    } catch(error) {
        catchError(error);
        return [];
    }
}

export async function addExperienceRequest(sector: string, ocupation: number, company: string, dateStart: string, dateEnd: string | null): Promise<boolean> {
    try {
        const data = new URLSearchParams();
        data.append('Sector', sector);
        data.append('Ocupation', ocupation.toString());
        data.append('Company', company);
        data.append('DateStart', dateStart);
        if(dateEnd) data.append('DateEnd', dateEnd);

        await fetch(SET_EXPERIENCE_URL, { 
            method: 'POST',
            body : data
        });
        return true;
    } catch(error) {
        catchError(error);
        return false;
    }
}

export async function getHaveExperience(): Promise<boolean> {
    try {
        const response = await fetch(GET_HAVE_EXPERIENCE_URL);
        return response.status === 204;
    } catch(error) {
        catchError(error);
        return false;
    }
}

export async function getKillerQuestions(): Promise<string> {
    try {
        const response = await fetch(GET_KQ_URL);
        return await response.text();
    } catch(error) {
        catchError(error);
        return '';
    }
}

export async function setHaveNoExperience(): Promise<boolean> {
    try {
        await fetch(SET_HAVE_NO_EXPERIENCE_URL, { method: 'POST' });
        return true;
    } catch(error) {
        catchError(error);
        return false;
    }
}